export default {
  PROFILE_UPDATED: "Profile updated",
};
